<div #fmenu class="fmenu"
  [class.opened]="fmenuOpen"
  [class.disabled]="0 == fmenuService.menus.length"
  (mouseleave)="onMouseLeave()"
  (mouseenter)="onMouseEnter()">

  <div class="fmenu-toggle">
    <button
      class="toggle-button alt fa-icon-button" type="button"
      [style.display]="0 == fmenuService.menus.length ? 'none' : ''"
      (click)="onToggleMenu()">
      <fa-icon [icon]="!fmenuOpen ? faCaretLeft : faCaretRight" class="fa-lg"></fa-icon>
    </button>
  </div>

  <ul *ngIf="fmenuOpen">
    <li *ngFor="let menu of fmenuService.menus; let i = index;">
      <a class="menu-item" [class.open]="parentFmenusOpen[i]" [tabindex]="0" 
      (keydown.Space)="fmenuOpen ? parentFmenusOpen[i] = !parentFmenusOpen[i] : fmenuOpen = true"
      (click)="fmenuOpen ? parentFmenusOpen[i] = !parentFmenusOpen[i] : fmenuOpen = true">
        <div class="menu-item-label">{{menu.header}}</div>
        <fa-icon [icon]="parentFmenusOpen[i] ? faCaretUp : faCaretDown" [class.menu-close]="!fmenuOpen" ngbTooltip="{{menu.header}}"></fa-icon>
      </a>
      <ul class="sub-menu-list" [class.open]="parentFmenusOpen[i] && fmenuOpen">
        <li *ngFor="let item of menu.itemSources" [class.invert-menu-box]="item.invert">
          <button type="button" class="menu-item"
            [disabled]="item.enabled === false"
            (keydown.Space)="onClickMenu(menu, item)"
            (click)="onClickMenu(menu, item)" [tabindex]="parentFmenusOpen[i] && fmenuOpen ? 0 : -1">
            <div class="menu-label" [innerHTML]="sanitizer.bypassSecurityTrustHtml(item.header)">
            </div>
          </button>
        </li>
      </ul>
    </li>
  </ul>
</div>
